// extracted by mini-css-extract-plugin
export default {"videoContent":"InputVideoDragger_videoContent__rMFYH","actions":"InputVideoDragger_actions__YNQF4"};